module.exports = __webpack_public_path__ + "img/logo-nodejs.5d51536d.svg";